import { render, staticRenderFns } from "./SecureSBGroupsSettings.vue?vue&type=template&id=165b623e"
import script from "./SecureSBGroupsSettings.vue?vue&type=script&lang=js"
export * from "./SecureSBGroupsSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports